import { Container } from "@mui/system";
import { Typography, Paper, Grid, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Page from "../components/Page";

//Hooks
import { useCollection } from "../hooks/useCollection";
import DeliveryTable from "../components/DeliveryTable";

function DeliveryNote() {
  const navigate = useNavigate();

  const { documents } = useCollection("Delivery");

  return (
    <Page title={"Delivery Note"}>
      <Container maxWidth="xl">
        <Paper elevation={6} sx={{ p: 4 }}>
          <Grid
            container
            spacing={3}
            sx={{ justifyContent: "space-between", marginBottom: 1 }}
          >
            <Grid item xs={12} sm={6} md={6}>
              <Typography variant="h4" sx={{ mb: 1 }}>
                Delivery Note
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            sx={{ justifyContent: "space-between", marginBottom: 1, mt: 1 }}
          >
            <Grid item xs={12} sm={3} md={3}>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate(`/dashboard/delivery-form/:id`)}
              >
                Create Delivery
              </Button>
            </Grid>
          </Grid>
          <DeliveryTable data={documents} />
        </Paper>
      </Container>
    </Page>
  );
}

export default DeliveryNote;
